import { createI18n } from 'vue-i18n';

import en from '@/locales/en.json';
import km from '@/locales/km.json';

export type Locale = 'en' | 'km';

const STORAGE_KEY = 'optimalhr.locale';

function readInitialLocale(): Locale {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === 'en' || v === 'km') return v;
  } catch {
    /* ignore */
  }
  return 'en';
}

export const i18n = createI18n({
  legacy: false,
  locale: readInitialLocale(),
  fallbackLocale: 'en',
  messages: { en, km },
  // Several v1 messages contain `|` (e.g., "Yes | Confirm") which vue-i18n
  // would otherwise interpret as plural rules.
  pluralRules: {},
});
